// Packages
import { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import rightangle from "../../assets/images/rightangle.svg";
import { Form } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import { BsXLg } from "react-icons/bs";
// Views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import leftarrow from "../../assets/images/leftarrow.svg";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import successimg from "../../assets/images/successimg.png";
import close from "../../assets/images/crosstick.png";
import { CircularProgress, Paper, Button } from "@material-ui/core";
import ReactPlayer from "react-player";
import Delete from "../../assets/images/Delete.png";
// Styles
import "./superAdmin.css";

// Services
import userService from "../../services/user.service";
import { getFromLocalStorage } from "../../utils/webStorage";
import AddQuestionDialog from "../schoolAdminPortal/Popups/AddQuestionDialog";
import SuccessDialog from "../schoolAdminPortal/Popups/SuccessDialog";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ConfirmationDialog from "../schoolAdminPortal/Popups/ConfirmationDialog";
import FailDialog from "../schoolAdminPortal/Popups/FailDialog";
import AddProductVideo from "../schoolAdminPortal/Popups/AddProductVideo";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
// Material Ui

class guidelinedetails extends Component {
  constructor() {
    super();
    this.state = {
      showfive: false,
      question: "",
      answer: "",
      showMessage: "",
      selectedFileData: [],
      fileId: null,
      submitting: false,
      fileName: "No File Choosen",
      titleProduct: "",
      detailsProduct: "",
      faqsDetailsResponses: [],
      productRelatedVideosDetailsResponses: [],
      selectedFAQa: null,
      selectedProductVideos: null,
      show: false,
      show1: false,
      disabled: false,
      questionDialog: false,
      successPopUp: false,
      message: "",
      redirect: false,
      confirmPopup: false,
      msg: "",
      questionId: "",
      failPopup: false,
      videoDialog: false,
      schoolId: getFromLocalStorage("schoolId"),
      loginRole: getFromLocalStorage("loginRole"),
      isDeleteQuestion: false,
    };
    this.changeHandlerForVideoUpload =
      this.changeHandlerForVideoUpload.bind(this);
  }
  handleModelfive() {
    this.setState({ showfive: !this.state.showfive });
  }

  cancelButtonClick() {
    this.getFAQ();
    this.getRelatedVideos();
  }
  componentDidMount() {
    const acticve = document.getElementById("guidelinedetails");
    if (acticve) {
      acticve.classList.add("active");
    }
    this.getFAQ();
    this.getRelatedVideos();
  }

  toggle = () =>
    this.setState((currentState) => ({ show: !currentState.show }));

  toggle1 = () =>
    this.setState((currentState) => ({ show1: !currentState.show1 }));

  addFAQPost = (question, answer, formRef) => {
    this.setState({ disabled: true });
    userService
      .addFAQPost(question, answer)
      .then((res) => {
        let showMessage = res.data.data;
        this.setState(
          {
            showMessage,
            disabled: false,
            questionDialog: false,
            successPopUp: true,
          },
          () => {
            formRef.current.setFieldValue("question", "");
            formRef.current.setFieldValue("answer", "");
          }
        );
        this.getFAQ();
      })
      .catch(() => {
        formRef.current.setFieldValue("question", "");
        formRef.current.setFieldValue("answer", "");
        this.setState({
          confirmPopup: false,
          msg: "Something went wrong",
          failPopup: true,
          submitting: false,
        });
      });
  };

  getFAQ() {
    userService
      .getFaqQuestions()
      .then((res) => {
        var faqsDetailsResponses = res.data.data.faqsDetailsResponses;
        this.setState({ faqsDetailsResponses });
      })
      .catch(() => {
        this.setState({
          confirmPopup: false,
          msg: "Something went wrong",
          failPopup: true,
          submitting: false,
        });
      });
  }

  openDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }
  closeDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }

  closeDialogSuccessVideos() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }

  changeHandlerForVideoUpload = (event, formRef) => {
    let file = event.target.files;
    this.setState({ selectedFileData: file });
    this.handleSubmissionForVideoUpload(file, formRef);
  };

  handleSubmissionForVideoUpload = async (filesToUpload, formRef) => {
    const { schoolId } = this.state;
    var fileName = "uploading...";
    var submitting = true;
    this.setState({ fileName, submitting });

    const data = new FormData();
    for (let i = 0; i < filesToUpload.length; i++) {
      data.append("file", filesToUpload[i]);
    }
    const currentUserId = getFromLocalStorage("currentUserId");
    data.append("userId", currentUserId);
    data.append("schoolId", schoolId);
    userService
      .uploadInvoice(data)
      .then((res) => {
        var fileId = res.data.data[0].id;
        var submitting = false;
        var fileName = res.data.data[0].fileName;
        formRef.current.setFieldValue("video", fileId);
        this.setState({ fileId, submitting, fileName });
      })
      .catch(() => {
        this.setState({ fileName: "Upload Failed", submitting: false });
        formRef.current.setFieldValue("video", "");
      });
  };

  addProductRelatedVideoPost = ({ title, description, video }, formRef) => {
    this.setState({ disabled: true });
    const { fileId } = this.state;
    userService
      .addRelatedProductPost(title, description, video)
      .then((res) => {
        let showMessage = res.data.data;
        this.setState({
          showMessage,
          disabled: false,
          successPopUp: true,
          showMessage: "Video Added Successfully",
          videoDialog: false,
        });
        formRef.current.setFieldValue("video", "");
        formRef.current.setFieldValue("title", "");
        formRef.current.setFieldValue("description", "");
        this.getRelatedVideos();
      })
      .catch(() => {
        this.setState({
          confirmPopup: false,
          msg: "Something went wrong",
          failPopup: true,
          submitting: false,
        });
        formRef.current.setFieldValue("video", "");
        formRef.current.setFieldValue("title", "");
        formRef.current.setFieldValue("description", "");
      });
  };
  getRelatedVideos() {
    userService
      .getRelatedVideo()
      .then((res) => {
        var productRelatedVideosDetailsResponses =
          res.data.data.productRelatedVideosDetailsResponses;
        this.setState({ productRelatedVideosDetailsResponses });
      })
      .catch(() => {
        this.setState({
          confirmPopup: false,
          msg: "Something went wrong",
          failPopup: true,
          submitting: false,
        });
      });
  }

  openDialog = (id) => {
    this.setState({
      open: !this.state.open,
      selectedFAQa: id,
    });
  };

  deleteFAQs = () => {
    const { questionId } = this.state;
    this.setState({
      submitting: true,
    });
    userService
      .deleteFAQsdata(questionId)
      .then((res) => {
        this.setState({
          confirmPopup: false,
          showMessage: "Question Removed Successfully",
          successPopUp: true,
          submitting: false,
        });
        this.getFAQ();
      })
      .catch(() => {
        this.setState({
          confirmPopup: false,
          msg: "Something went wrong",
          failPopup: true,
          submitting: false,
        });
      });
  };

  closeDialog() {
    this.setState({ open: !this.state.open });
  }

  openDialogRemoved() {
    this.setState({ openRemove: !this.state.openRemove });
  }

  closeDialogRemoved() {
    this.setState({ openRemove: !this.state.openRemove });
  }

  openDialogone() {
    this.setState({ openone: !this.state.openone });
  }

  deleteVideoLibrary = () => {
    const { questionId } = this.state;
    this.setState({
      submitting: true,
    });
    userService
      .deleteProductVideos(questionId)
      .then((res) => {
        this.setState({
          confirmPopup: false,
          showMessage: "Question Removed Successfully",
          successPopUp: true,
          submitting: false,
        });
        this.getRelatedVideos();
      })
      .catch(() => {
        this.setState({
          confirmPopup: false,
          msg: "Something went wrong",
          failPopup: true,
          submitting: false,
        });
      });
  };

  openDialogVideos = (id) => {
    this.setState({
      open: !this.state.open,
    });
    var selectedProductVideos = id;
    this.setState({ selectedProductVideos });
  };

  closeDialogVideos() {
    this.setState({ open: !this.state.open });
  }

  openDialogRemovedVideos() {
    this.setState({ openRemove: !this.state.openRemove });
  }

  closeDialogRemovedVideos() {
    this.setState({ openRemove: !this.state.openRemove });
  }

  openDialogoneVideos() {
    this.setState({ openone: !this.state.openone });
  }
  closeDialogSuccessVideos() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }

  toggleQuestionDialog = () => {
    this.setState({ questionDialog: false });
  };

  toggleSuccessDialog = () => {
    const { successPopUp } = this.state;
    this.setState({ successPopUp: !successPopUp });
  };

  toggleConfirmPopup = () => {
    const { confirmPopup } = this.state;
    this.setState({ confirmPopup: !confirmPopup });
  };

  toggleFailDialog = () => {
    const { failPopup } = this.state;
    this.setState({ failPopup: !failPopup });
  };

  toggleVideoDialog = () => {
    const { videoDialog } = this.state;
    this.setState({ videoDialog: !videoDialog });
  };

  render() {
    const {
      showMessage,
      submitting,
      fileName,
      faqsDetailsResponses,
      productRelatedVideosDetailsResponses,
      successPopUp,
      redirect,
      questionDialog,
      msg,
      confirmPopup,
      failPopup,
      videoDialog,
      isDeleteQuestion,
      loginRole,
    } = this.state;

    if (redirect) {
      return <Redirect to="/website" />;
    }
    return (
      <>
        {loginRole === "SUPER ADMIN" ? (
          <div className="">
            <SuperAdminDashboard />
            <div className="content-layout height-90-vh">
              <Tabs>
                <div className="row w-100">
                  <div className="col-12 col-md-4 col-lg-3 fixed-left-container">
                    <TabList className="w-100">
                      <div className="pd-5">
                        <button
                          className="custom-back-button mg-bottom-10 mg-top-10"
                          onClick={() => this.setState({ redirect: true })}
                        >
                          <span className="custom-back-button-icon">
                            <ArrowBackIcon className="backarrow-icon" />
                          </span>
                          <div className="custom-back-button-text d-flex-center w-100">
                            <span className="bold fs-18">
                              Manage Guidelines
                            </span>
                          </div>
                        </button>
                      </div>
                      <Tab className="p-3 black">
                        <div className="landing-dtls">
                          <p className="">FAQs</p>
                          <span className="">
                            <img src={rightangle} alt=""></img>
                          </span>
                        </div>
                      </Tab>
                      <Tab className=" p-3  black">
                        <div className="landing-dtls">
                          <p>Product related videos</p>
                          <span className="">
                            <img alt="" src={rightangle}></img>
                          </span>
                        </div>
                      </Tab>
                    </TabList>
                  </div>
                  {/* FAQs info */}
                  <div className="col-12 col-md-8 col-lg-9 w-100 scrollit">
                    <TabPanel>
                      <div className="panel-content conclass-website">
                        {faqsDetailsResponses &&
                          faqsDetailsResponses.map((item, index) => (
                            <Paper className="pd-5 mg-bottom-20">
                              <div className="row">
                                <div className="col-lg-9 col-md-9">
                                  <label className=" fs-18 faqtext">
                                    QUESTION:-{" " + (index + 1)}
                                  </label>
                                  <br />
                                  <input
                                    type="text"
                                    name=""
                                    className="w-100 faqtextbox1 "
                                    placeholder={item.question}
                                    value={item.question}
                                  ></input>
                                </div>
                              </div>
                              <div className="clear20"></div>
                              <div className="row">
                                <div className="col-lg-9 col-md-9 col-12">
                                  <label className=" fs-18 faqtext">
                                    ANSWER
                                  </label>
                                  <br />
                                  <textarea
                                    id=""
                                    className="fs-16 w-100 faqanswerbox "
                                    name=""
                                    rows="4"
                                    cols="50"
                                    placeholder={item.answer}
                                    value={item.answer}
                                  />
                                </div>
                              </div>
                              <button
                                className="status mg-top-10"
                                onClick={() => {
                                  this.setState({
                                    questionId: item.id,
                                    confirmPopup: true,
                                    msg: "Are you sure you want to remove this question ?",
                                    isDeleteQuestion: true,
                                  });
                                }}
                              >
                                Remove
                              </button>
                            </Paper>
                          ))}

                        <div>
                          <button
                            className="addBtnn2 mng-padding"
                            onClick={() =>
                              this.setState({ questionDialog: true })
                            }
                          >
                            <AddIcon className="mr-2 addIconSc " />
                            Add New
                          </button>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="panel-content conclass-website">
                        {productRelatedVideosDetailsResponses &&
                          productRelatedVideosDetailsResponses.map(
                            (item, index) => (
                              <Paper className="pd-5 mg-bottom-10">
                                <div className="row">
                                  <div className="col-lg-9 col-md-9">
                                    <label className=" fs-18 faqtext">
                                      UPLOADED VIDEO
                                    </label>
                                    <br />
                                    <div>
                                      <ReactPlayer
                                        className="product-video"
                                        url={item.uploadedFiles.filePath}
                                        playing={false}
                                        controls
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="clear20"></div>
                                <div className="row">
                                  <div className="col-lg-9 col-md-9">
                                    <label className=" fs-18 faqtext">
                                      TITLE
                                    </label>
                                    <br />
                                    <input
                                      type="text"
                                      name=""
                                      className="w-100 faqtextbox1 "
                                      placeholder="Complete Product Walkthrough"
                                      value={item.title}
                                    ></input>
                                  </div>
                                </div>
                                <div className="clear20"></div>

                                <div className="row">
                                  <div className="col-lg-9 col-md-9">
                                    <label className=" fs-18 faqtext">
                                      DETAILS
                                    </label>
                                    <br />
                                    <textarea
                                      id=""
                                      className="fs-16 w-100 faqanswerbox "
                                      name=""
                                      rows="4"
                                      cols="50"
                                      placeholder="Dummy Mockup and dummy content is used here Use video and data analysis to detect vulnerabilities. Decide what to focus on and develop technical and tactical strategies to im, Dummy Mockup and dummy content is used here Use video and data analysis to detect vulnerabilities. Decide what to focus on and develop technical and tactical strategies to im"
                                      value={item.details}
                                    ></textarea>
                                  </div>
                                </div>
                                <button
                                  className="status mg-top-10"
                                  onClick={() => {
                                    this.setState({
                                      questionId: item.id,
                                      confirmPopup: true,
                                      msg: "Are you sure you want to remove this video ?",
                                      isDeleteQuestion: false,
                                    });
                                  }}
                                >
                                  Remove
                                </button>
                              </Paper>
                            )
                          )}

                        <div>
                          <button
                            className="saveBtn1"
                            onClick={() => this.setState({ videoDialog: true })}
                          >
                            Add new
                          </button>
                        </div>
                      </div>
                    </TabPanel>
                  </div>
                </div>
              </Tabs>
            </div>

            {submitting && (
              <CircularProgress
                style={{
                  width: "45px",
                  height: "44px",
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  zIndex: "99",
                }}
                color="secondary"
              />
            )}

            <AddQuestionDialog
              successPopUp={questionDialog}
              toggleSuccessDialog={this.toggleQuestionDialog}
              addQuestion={this.addFAQPost}
            />

            <SuccessDialog
              successPopUp={successPopUp}
              toggleSuccessDialog={this.toggleSuccessDialog}
              msg={showMessage}
            />

            <ConfirmationDialog
              confirmPopUp={confirmPopup}
              toggleConfirmDialog={this.toggleConfirmPopup}
              btnColor="red"
              btnText="Yes"
              ApiToCall={
                isDeleteQuestion ? this.deleteFAQs : this.deleteVideoLibrary
              }
              msg={msg}
            />

            <FailDialog
              open={failPopup}
              msg={msg}
              closeFailDialog={this.toggleFailDialog}
            />

            <AddProductVideo
              fileName={fileName}
              successPopUp={videoDialog}
              toggleSuccessDialog={this.toggleVideoDialog}
              addQuestion={this.addProductRelatedVideoPost}
              changeHandlerForVideoUpload={this.changeHandlerForVideoUpload}
            />
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </>
    );
  }
}

export default guidelinedetails;
